import React, {Component, Fragment} from 'react';
import './NewPoll.scss';
import {
    getCardSpending,
    getCardSpendingRange,
    getCategoryPercentages,
    getCategoryPercentagesRange,
    getChitiOverviewOfCurrentMonth,
    getChitiOverviewRange
} from '../util/APIUtils';
import {Card, Collapse, DatePicker, List, Modal, Radio, Select, Switch, Tabs, Button} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {convertToLocalFormat} from "../util/utils";
import moment from "moment";
import 'moment-timezone';
import PayItemListOverview from "./PayItemListOverview";
import {dateFormat} from "../constants";
import {Bar, BarChart, CartesianGrid, Cell, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import {getUserTimezone} from '../util/timezone';
import {CATEGORY_ICONS} from '../constants/icons';

const {Panel} = Collapse;
const {MonthPicker} = DatePicker;
const {Option} = Select;
const {TabPane} = Tabs;

const Item = List.Item;
const {Meta} = Card;

class ChitiOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            overview: [],
            currentOverview: [],
            categoryPercentages: [],
            cardSpending: [],
            total: {},
            openDetail: false,
            selectCategory: "",
            date: moment().format(dateFormat),
            dateTo: moment().format(dateFormat),
            showAddModal: false,
            selectedChart: 'category',
            chartType: 'bar',
            chartOrientation: 'horizontal',
            categorySortBy: 'amount-high'
        };
    }

    componentDidMount() {
        const date = moment().format(dateFormat);
        getChitiOverviewRange(date, date)
            .then(response => {
                this.setState({currentOverview: response, total: this.getTotal(response)});
            })
            .catch(error => {
                this.setState({currentOverview: [], total: 0});
                console.error("Failed to fetch overview:", error.message || error);
            });
        
        getCategoryPercentagesRange(date, date)
            .then(response => {
                this.setState({categoryPercentages: response});
            })
            .catch(error => {
                console.error("Failed to fetch percentages:", error.message || error);
            });
        
        getCardSpendingRange(date, date)
            .then(response => {
                this.setState({cardSpending: response});
            })
            .catch(error => {
                console.error("Failed to fetch card spending:", error.message || error);
            });
        
        window.addEventListener('expenseUpdated', this.reloadOverview);
    }

    componentWillUnmount() {
        window.removeEventListener('expenseUpdated', this.reloadOverview);
    }

    reloadOverview = () => {
        const { date, dateTo } = this.state;
        console.log('Reloading overview due to expense update');
        getChitiOverviewRange(date, dateTo).then(response => {
            this.setState({currentOverview: response, total: this.getTotal(response)});
        });
        getCategoryPercentagesRange(date, dateTo).then(response => {
            this.setState({categoryPercentages: response});
        });
        getCardSpendingRange(date, dateTo).then(response => {
            this.setState({cardSpending: response});
        });
    }

    getTotal = (currentOverview) => {
        return currentOverview.reduce((total, x) => (total = total + x.total), 0);
    }

    getColorFromName = (name) => {
        const colors = ['#ff7875', '#ffa940', '#597ef7', '#73d13d', '#ff85c0', '#9254de', '#ffc53d', '#36cfc9', '#5cdbd3', '#95de64', '#ff9c6e', '#b37feb', '#69c0ff', '#5cdbd3', '#ffadd2'];
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    }

    getCategoryIcon = (icon) => {
        if (icon) {
            const iconData = CATEGORY_ICONS.find(i => i.value === icon);
            if (iconData) {
                return <span style={{ fontSize: '24px' }}>{iconData.label}</span>;
            }
        }
        return <span style={{ fontSize: '24px' }}>💵</span>;
    }

    getCategoryColor = (categoryName) => {
        return this.getColorFromName(categoryName);
    }

    groupBy = (items, key) => {
        if (!items || items.length === 0) {
            return {};
        }
        return items.reduce(
            (result, item) => ({
                ...result,
                [item[key]]: [
                    ...(result[item[key]] || []),
                    item,
                ],
            }),
            {},
        );
    };

    redirectToDetails = (category) => {
        this.setState({openDetail: true, selectedCategory: category.category});
    }

    handleCancel = () => {
        this.setState({openDetail: false});
        this.reloadOverview();
    }

    showAddModal = () => {
        console.log('showAddModal called, setting showAddModal to true');
        this.setState({ showAddModal: true }, () => {
            console.log('showAddModal state updated:', this.state.showAddModal);
        });
    }

    handleAddModalClose = () => {
        this.setState({ showAddModal: false });
        // Reload overview after adding
        this.reloadOverview();
    }

    handleInputDateChange = (date) => {
        if (!date) return;
        const datef = moment(date).format(dateFormat);
        this.setState({ date: datef, overview: [], currentOverview: [], categoryPercentages: [], total: {}, openDetail: false, selectCategory: '' }, () => {
            this.reloadOverview();
        });
    }

    handleToDateChange = (date) => {
        if (!date) return;
        const datef = moment(date).format(dateFormat);
        this.setState({ dateTo: datef, overview: [], currentOverview: [], categoryPercentages: [], total: {}, openDetail: false, selectCategory: '' }, () => {
            this.reloadOverview();
        });
    }

    handleQuickMonth = (offset) => {
        // offset 0 = current month, -1 = prev from selected, +1 = next from selected
        const base = offset === 0 ? moment() : moment(this.state.date).add(offset, 'months');
        const datef = base.clone().startOf('month').format(dateFormat);
        const dateTo = base.clone().endOf('month').format(dateFormat);
        this.setState({ date: datef, dateTo, overview: [], currentOverview: [], categoryPercentages: [], total: {}, openDetail: false, selectCategory: '' }, () => {
            this.reloadOverview();
        });
    }

    render() {
        const {currentOverview, categoryPercentages, cardSpending, total, openDetail, selectedCategory, date, dateTo, showAddModal, chartType, selectedChart, chartOrientation, categorySortBy} = this.state;

        return (
            <div style={{ background: '#f5f7fa', minHeight: '100vh', paddingBottom: '80px' }}>
                {/* Header */}
                <div style={{ 
                    background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                    padding: '24px',
                    color: 'white',
                    borderRadius: '16px',
                    boxShadow: '0 4px 20px rgba(24, 144, 255, 0.3)',
                    margin: '16px'
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                <span style={{ fontSize: '12px', opacity: 0.8 }}>From:</span>
                                <MonthPicker
                                    onChange={this.handleInputDateChange}
                                    value={moment(date)}
                                    size="large"
                                    style={{ borderRadius: '12px' }}
                                    allowClear={false}
                                />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                <span style={{ fontSize: '12px', opacity: 0.8 }}>To:</span>
                                <MonthPicker
                                    onChange={this.handleToDateChange}
                                    value={moment(dateTo)}
                                    size="large"
                                    style={{ borderRadius: '12px' }}
                                    allowClear={false}
                                />
                            </div>
                        </div>

                        {/* Quick month selector — compact, left-aligned */}
                        <div style={{ display: 'flex', gap: '6px' }}>
                        {[
                            { label: '‹ Prev', offset: -1 },
                            { label: 'Current', offset: 0 },
                            { label: 'Next ›', offset: 1 },
                        ].map(({ label, offset }) => {
                            const isActive = offset === 0
                                ? moment(date).isSame(moment(), 'month')
                                : false;
                            return (
                                <button
                                    key={offset}
                                    onClick={() => this.handleQuickMonth(offset)}
                                    style={{
                                        padding: '3px 12px',
                                        borderRadius: '8px',
                                        border: isActive ? '1.5px solid #fff' : '1.5px solid rgba(255,255,255,0.35)',
                                        background: isActive ? 'rgba(255,255,255,0.22)' : 'transparent',
                                        color: 'white',
                                        fontWeight: isActive ? 700 : 400,
                                        fontSize: '11px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        letterSpacing: '0.2px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {label}
                                </button>
                            );
                        })}
                        </div>
                    </div>

                    <div style={{ fontSize: '15px', opacity: 0.95, marginBottom: '12px', fontWeight: 500, letterSpacing: '0.5px' }}>
                        {moment(date).format("MMM YYYY")} – {moment(dateTo).format("MMM YYYY")}
                    </div>
                    <div style={{ fontSize: '48px', fontWeight: 800, letterSpacing: '-2px' }}>
                        ${convertToLocalFormat(total, 0)}
                    </div>
                    <div style={{ fontSize: '13px', opacity: 0.85, marginTop: '8px' }}>Total Spending</div>
                </div>

                {/* Categories */}
                <div style={{ padding: '24px 16px' }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px'
                    }}>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 700,
                            color: '#1a1a1a'
                        }}>
                            Categories
                        </div>
                        <Select
                            value={categorySortBy}
                            onChange={(value) => this.setState({ categorySortBy: value })}
                            style={{ width: 160, borderRadius: '8px' }}
                            size="middle"
                        >
                            <Select.Option value="amount-high">Amount: High to Low</Select.Option>
                            <Select.Option value="amount-low">Amount: Low to High</Select.Option>
                            <Select.Option value="name-asc">Name: A to Z</Select.Option>
                            <Select.Option value="name-desc">Name: Z to A</Select.Option>
                        </Select>
                    </div>
                    <div style={{ 
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))',
                        gap: '12px'
                    }}>
                        {[...currentOverview].sort((a, b) => {
                            switch(categorySortBy) {
                                case 'amount-high':
                                    return b.total - a.total;
                                case 'amount-low':
                                    return a.total - b.total;
                                case 'name-asc':
                                    return a.category.localeCompare(b.category);
                                case 'name-desc':
                                    return b.category.localeCompare(a.category);
                                default:
                                    return 0;
                            }
                        }).map((item, index) => {
                            const percentageData = categoryPercentages.find(p => p.category === item.category);
                            const percentage = percentageData ? percentageData.percentage : 0;
                            return (
                                <div
                                    key={index}
                                    onClick={() => this.redirectToDetails(item)}
                                    style={{
                                        background: 'white',
                                        borderRadius: '16px',
                                        padding: '16px 12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        minHeight: '120px',
                                        border: '1px solid rgba(0,0,0,0.02)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-4px)';
                                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(24, 144, 255, 0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                                    }}
                                >
                                    <div style={{ marginBottom: '10px', fontSize: '28px' }}>
                                        {this.getCategoryIcon(item.icon)}
                                    </div>
                                    <div style={{ 
                                        fontSize: '12px',
                                        color: '#666',
                                        marginBottom: '6px',
                                        lineHeight: 1.3,
                                        fontWeight: 600
                                    }}>
                                        {item.category}
                                    </div>
                                    <div style={{ 
                                        fontSize: '18px',
                                        fontWeight: 800,
                                        color: '#1a1a1a',
                                        marginBottom: '4px',
                                        lineHeight: 1
                                    }}>
                                        ${convertToLocalFormat(item.total, 0)}
                                    </div>
                                    <div style={{ 
                                        fontSize: '11px',
                                        color: '#999',
                                        fontWeight: 600,
                                        background: '#f5f7fa',
                                        padding: '2px 8px',
                                        borderRadius: '8px'
                                    }}>
                                        {percentage.toFixed(1)}%
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Charts */}
                {categoryPercentages.length > 0 && (
                    <div style={{ padding: '0 16px 24px' }}>
                        <div style={{ 
                            fontSize: '20px',
                            fontWeight: 700,
                            marginBottom: '16px',
                            color: '#1a1a1a'
                        }}>
                            Analytics
                        </div>
                        <div style={{
                            background: 'white',
                            borderRadius: '20px',
                            padding: '24px',
                            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                            border: '1px solid rgba(0,0,0,0.02)'
                        }}>
                            <div style={{ 
                                display: 'flex', 
                                flexDirection: 'column',
                                gap: '12px',
                                marginBottom: '20px'
                            }}>
                                <div>
                                    <div style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: '6px', fontWeight: 500 }}>
                                        Chart Data
                                    </div>
                                    <Radio.Group
                                        value={selectedChart}
                                        onChange={(e) => this.setState({ selectedChart: e.target.value })}
                                        buttonStyle="solid"
                                        size="small"
                                    >
                                        <Radio.Button value="category">Category</Radio.Button>
                                        <Radio.Button value="card">Card</Radio.Button>
                                    </Radio.Group>
                                </div>
                                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-end' }}>
                                    <div>
                                        <div style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: '6px', fontWeight: 500 }}>
                                            Chart Type
                                        </div>
                                        <Radio.Group
                                            value={chartType}
                                            onChange={(e) => this.setState({ chartType: e.target.value })}
                                            buttonStyle="solid"
                                            size="small"
                                        >
                                            <Radio.Button value="bar">Bar</Radio.Button>
                                            <Radio.Button value="pie">Pie</Radio.Button>
                                        </Radio.Group>
                                    </div>
                                    {chartType === 'bar' && (
                                        <div>
                                            <div style={{ fontSize: '12px', color: '#8c8c8c', marginBottom: '6px', fontWeight: 500 }}>
                                                Orientation
                                            </div>
                                            <Switch
                                                checked={chartOrientation === 'horizontal'}
                                                onChange={(checked) => this.setState({ chartOrientation: checked ? 'horizontal' : 'vertical' })}
                                                checkedChildren="H"
                                                unCheckedChildren="V"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            {selectedChart === 'category' && (
                                <ResponsiveContainer width="100%" height={500}>
                                    {chartType === 'bar' ? (
                                        <BarChart 
                                            data={[...categoryPercentages].sort((a, b) => b.total - a.total).map(item => ({
                                                name: item.category,
                                                value: item.total
                                            }))} 
                                            layout={chartOrientation === 'horizontal' ? 'vertical' : 'horizontal'}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                            {chartOrientation === 'horizontal' ? (
                                                <>
                                                    <XAxis type="number" tick={{ fontSize: 12 }} />
                                                    <YAxis type="category" dataKey="name" tick={{ fontSize: 12 }} width={100} />
                                                </>
                                            ) : (
                                                <>
                                                    <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                                                    <YAxis tick={{ fontSize: 12 }} />
                                                </>
                                            )}
                                            <Tooltip formatter={(value) => `$${convertToLocalFormat(value, 0)}`} />
                                            <Bar dataKey="value" name="Amount" radius={chartOrientation === 'horizontal' ? [0, 8, 8, 0] : [8, 8, 0, 0]}>
                                                {categoryPercentages.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={this.getCategoryColor(entry.category)} />
                                                ))}
                                            </Bar>
                                        </BarChart>
                                    ) : (
                                        <PieChart>
                                            <Pie
                                                data={categoryPercentages.map(item => ({
                                                    name: item.category,
                                                    value: item.total
                                                }))}
                                                cx="50%"
                                                cy="50%"
                                                labelLine={false}
                                                label={({name, percent}) => `${name} ${(percent * 100).toFixed(0)}%`}
                                                outerRadius={90}
                                                dataKey="value"
                                            >
                                                {categoryPercentages.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={this.getCategoryColor(entry.category)} />
                                                ))}
                                            </Pie>
                                            <Tooltip formatter={(value) => `$${convertToLocalFormat(value, 0)}`} />
                                        </PieChart>
                                    )}
                                </ResponsiveContainer>
                            )}
                            
                            {selectedChart === 'card' && cardSpending.length > 0 && (
                                <ResponsiveContainer width="100%" height={500}>
                                    <BarChart
                                        data={cardSpending.map(item => ({
                                            name: item.cardName,
                                            value: item.total
                                        }))}
                                        layout={chartOrientation === 'horizontal' ? 'vertical' : 'horizontal'}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                        {chartOrientation === 'horizontal' ? (
                                            <>
                                                <XAxis type="number" tick={{ fontSize: 12 }} />
                                                <YAxis type="category" dataKey="name" tick={{ fontSize: 12 }} width={100} />
                                            </>
                                        ) : (
                                            <>
                                                <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                                                <YAxis tick={{ fontSize: 12 }} />
                                            </>
                                        )}
                                        <Tooltip formatter={(value) => `$${convertToLocalFormat(value, 0)}`} />
                                        <Bar dataKey="value" name="Amount" fill="#1890ff" radius={chartOrientation === 'horizontal' ? [0, 8, 8, 0] : [8, 8, 0, 0]} />
                                    </BarChart>
                                </ResponsiveContainer>
                            )}
                        </div>
                    </div>
                )}

                {/* Details Modal */}
                {openDetail && (
                    <Modal 
                        maskClosable={false} 
                        width="90%"
                        style={{ maxWidth: '600px', top: 80 }}
                        title={<span style={{ fontSize: '18px', fontWeight: 600 }}>{selectedCategory}</span>}
                        open={openDetail}
                        visible={openDetail}
                        onCancel={this.handleCancel} 
                        footer={null}
                        bodyStyle={{ padding: '16px', maxHeight: '70vh', overflowY: 'auto' }}
                    >
                        <PayItemListOverview 
                            date={date}
                            dateTo={dateTo}
                            category={selectedCategory}
                            onUpdate={() => {
                                this.reloadOverview();
                            }}
                        />
                    </Modal>
                )}


            </div>
        );
    }

    categoryList(overview) {
        const items = []
        for (const m in overview) {
            items.push(<Panel header={m} key={m}>
                <List dataSource={overview[m]} grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 4,
                    lg: 4,
                    xl: 6,
                    xxl: 6,
                }}
                      renderItem={item => (
                          <Item>
                              <Card>
                                  <Meta
                                      avatar={this.getCategoryIcon(item.category)}
                                      title={item.category}
                                      description={
                                          moment(item.date).tz(getUserTimezone()).format("Do MMMM YYYY") + " - " +
                                          convertToLocalFormat(item.total, 0)}
                                  /></Card>
                          </Item>
                      )}>
                </List>
            </Panel>)

        }
        return items;
    }
}

export default ChitiOverview;

